export interface IVacationAndSickBalance {
  HrRef: number;
  /** Vacation Days Available Balance */
  VacationBalance: number | null;
  /** Sick Days Available Balance */
  SickBalance: number | null;
  /** PTO Days Available Balance - either PTO is used or Vacation Balance and Sick Balance is used */
  PtoBalance: number | null;
  IsPto: boolean;
}

/** View-ready leave balances in days; null means "not reported", never zero. */
export interface LeaveBalanceView {
  vacation: number | null;
  sick: number | null;
  pto: number | null;
  isPto: boolean;
}

/**
 * Normalize a `/api/hrrm/employee/vacationandsick` payload for display.
 *
 * The DTO is declared PascalCase but the serializer may emit camelCase, so each
 * field is read under both spellings. Shared by the web and NativeScript
 * Individual Time Entry headers so one casing fix covers both.
 */
export function toLeaveBalanceView(
  info: IVacationAndSickBalance | null | undefined
): LeaveBalanceView | null {
  if (!info) {
    return null;
  }

  const loose = info as unknown as Record<string, unknown>;
  const days = (pascal: unknown, camel: unknown): number | null => {
    const raw = pascal ?? camel;
    if (raw == null || raw === '') {
      return null;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  };

  return {
    vacation: days(info.VacationBalance, loose['vacationBalance']),
    sick: days(info.SickBalance, loose['sickBalance']),
    pto: days(info.PtoBalance, loose['ptoBalance']),
    isPto: Boolean(info.IsPto ?? loose['isPto'] ?? false),
  };
}
